import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UniteDeProduction__SecteurFournisseurDTO} from '../../../../../core/dtos/unite-de-production__secteur-fournisseur-dto';
import {UniteDeProduction__secteurFournisseurService} from '../../../../../core/services/entities/unite-de-production__secteur-fournisseur.service';
import {Subscription} from 'rxjs';
import {UtilsService} from '../../../../../core/utils/utils.service';
import {MSG_KEY, MSG_SEVERITY} from '../../../../../core/constants';
import {ToastService} from '../../../../../core/services/technique/toast.service';
import {ButtonThemeEnum} from '../../../../../shared/ui/button/button-theme-enum';

@Component({
    selector: 'yo-dialog-remarque-commande',
    templateUrl: './dialog-remarque-commande.component.html',
    styleUrls: ['./dialog-remarque-commande.component.scss'],
    standalone: false
})
export class DialogRemarqueCommandeComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  @Input() canWrite: boolean = false;

  displayDialog = false;
  selectedUdpSf: UniteDeProduction__SecteurFournisseurDTO;
  remarqueCommande: string = '';

  private subUdpSf: Subscription;

  constructor(private udpSecteurFournisseurSvc: UniteDeProduction__secteurFournisseurService,
              public utils: UtilsService,
              private toastSvc: ToastService) {}

  ngOnInit(): void {
    this.subUdpSf = this.udpSecteurFournisseurSvc.udpSecteurFournisseur$.subscribe(response => {
      this.selectedUdpSf = response;
      this.remarqueCommande = response?.remarqueCommande || '';
      this.displayDialog = true;
    });
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subUdpSf);
  }

  closeDialog() {
    this.displayDialog = false;
  }

  saveRemarque() {
    this.udpSecteurFournisseurSvc.saveRemarqueCommande(this.selectedUdpSf.id, this.remarqueCommande).subscribe(() => {
      this.udpSecteurFournisseurSvc.announceRemarqueCommandeSaved(this.selectedUdpSf.id, this.remarqueCommande);
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Remarque sauvegardée`);
      this.closeDialog();
    });
  }
}
